import DeckWithHover from './DeckWithHover';
const { Table} = require('react-bootstrap');

var darkGrey = "#b5aea8";

var tableStyle = {width: 'auto', borderRadius: '10px', overflow: 'hidden', userSelect:'none', backgroundColor: darkGrey};

// Framed as the card row is (CardRow.js), so the two are the same height with their cards level: an 18px row above the
// cards (here the decks' names), 4px over them, and 22px under them (here how many cards are left)
// InOrder: the event piles listed in their order (looking back over a finished game, where every card is known)
function CardDecks({Civil,Military,Current,CurrentKnown,Future,MilitaryCandidates,InOrder = false})
{
    return(
        <Table borderless style={tableStyle}>
            <tbody style={{backgroundColor: darkGrey}}>
                <tr style={{padding:0, fontWeight:'bold', fontFamily: 'Arial, Helvetica, Sans-Serif', fontSize:'.7em', height: '18px', lineHeight: '18px'}}>
                    <td style={{backgroundColor: darkGrey, padding:0}}/>
                    <td style={{backgroundColor: darkGrey, padding:0, verticalAlign:'bottom'}}>Civil</td>
                    <td style={{backgroundColor: darkGrey, padding:0, verticalAlign:'bottom'}}>Military</td>
                    <td style={{backgroundColor: darkGrey, padding:0, verticalAlign:'bottom'}}>Current</td>
                    <td style={{backgroundColor: darkGrey, padding:0, verticalAlign:'bottom'}}>Future</td>
                    <td style={{backgroundColor: darkGrey, padding:'0px'}}/>
                </tr>
                <tr>
                    <td style={{backgroundColor: darkGrey, padding: '0 2px'}}/>
                    <td style={{backgroundColor: darkGrey, padding: '4px 2px 0'}}>
                        <DeckWithHover deck={Civil} deckColor={"#c9ac38"} Label="Civil deck"/>
                    </td>
                    <td style={{backgroundColor: darkGrey, padding: '4px 2px 0'}}>
                        <DeckWithHover deck={Military} deckColor={"#7c7770"} Candidates={MilitaryCandidates} Label="Military deck"/>
                    </td>
                    <td style={{backgroundColor: darkGrey, padding: '4px 2px 0'}}>
                        {/* The top card, when this player has looked at it (Joan of Arc), lies face up on the deck */}
                        <DeckWithHover deck={Current} Known={CurrentKnown} deckColor={"#75750e"} Backs Label="Current events"
                            Top={Current[0] && Current[0].type !== 'Hidden' && Current.some(card => card.type === 'Hidden') ? Current[0] : null}
                            InOrder={InOrder} OrderNote="Next to be revealed first"/>
                    </td>
                    <td style={{backgroundColor: darkGrey, padding: '4px 2px 0'}}>
                        {/* (prepared events go on top of the future events) */}
                        <DeckWithHover deck={Future} deckColor={"#75750e"} Backs Label="Future events"
                            InOrder={InOrder} OrderNote="Most recently prepared first"/>
                    </td>
                    <td style={{backgroundColor: darkGrey, padding: '0 2px'}}/>
                </tr>
                <tr style={{height: '22px', lineHeight: '22px'}}>
                    <td style = {{backgroundColor: darkGrey, padding:0}} />
                    <td style = {{backgroundColor: darkGrey, padding:0}}>
                        {Civil.length}
                    </td>
                    <td style = {{backgroundColor: darkGrey, padding:0}}>
                        {Military.length}
                    </td>
                    <td style = {{backgroundColor: darkGrey, padding:0}}>
                        {Current.length}
                    </td>
                    <td style = {{backgroundColor: darkGrey, padding:0}}>
                        {Future.length}
                    </td>
                    <td  style = {{backgroundColor: darkGrey, padding:0}}/>
                </tr>
            </tbody>
        </Table>
    )
}

export default CardDecks;